<!--
	作者：Shujuan Sun
	时间：2017-04-24
	描述：车辆监控页面_地图组件
-->
<template>
	<div v-bind:style="mapStyle" v-loading="loadingmap" element-loading-text="加载中">
		<baidu-map style="height: 100%;box-shadow: 3px 3px 2px #888888" :center="mapCenter" :zoom="mapZoom" :scroll-wheel-zoom="enableScroll" :map-click="enableMapClick" @ready="ready">
		</baidu-map>
		<!--路况、卫星、围栏、路线（画路线）、测量、标注、规划、提示、清空-->
		<menu-map 
			:currentMenu='currentMenu' 
			v-on:trafficMode="traffic" 
			v-on:satellite="isHybridMap=!isHybridMap"  
			v-on:measure="enableMesaureTool =! enableMesaureTool"  
			v-on:routePlan="pathPlan" 
			v-on:changeInfoBox="setInfoWindow"  
			></menu-map>
		<menu-vehicle 
			v-if="showMenuVehicle" 
			:clickedInfo="clickedInfo" 
			v-on:streetView="jieJing" 
			v-on:makePlan="routePlan">
		</menu-vehicle>
		<menu-status
			v-on:carTypeOnMap1="carTypeOnMap1"
			v-on:carTypeOnMap2="carTypeOnMap2" 
			v-on:carStatusOnMap1="carStatusOnMap1"
			v-on:carStatusOnMap2="carStatusOnMap2"
			v-on:carStatusOnMap3="carStatusOnMap3" 
			></menu-status>
		<menu-status-rescue
			v-on:sceneOnMap1="sceneOnMap1"
			v-on:sceneOnMap2="sceneOnMap2"
			v-on:sceneOnMap3="sceneOnMap3"
			></menu-status-rescue>
		<menu-map-tool 
			:currentMenu='currentMenu' 
			:enableDrawingTool='enableDrawingTool'   
			:infoType='infoType'
			:infoWindowMenu='infoWindowMenu' 
			v-on:noWin='noInfo' 
			v-on:simpleWin="simpleInfo" 
			v-on:standardWin="standardInfo" 
			:measureType='measureType' 
			:enableMesaureTool='enableMesaureTool' 
			v-on:meRoad="measureRoad" 
			v-on:meBeeline="measureBeeline" 
			v-on:meArea="measureArea" 
			v-on:coordinate="getCoordinate" 
			v-on:searchAddress="getAddress" 
			v-on:clearMeasure="measureClear" 
			v-on:searchAdds="searchAds"></menu-map-tool>		
		<!--街景窗口-->
		<div v-if="showStreetView" class="street_view">
			<street-map :viewPosi="streetPosi" v-on:closeView="closeStreetView"></street-map>
		</div>
		<!--倒计时刷新提示-->
		<div class="refresh_time" v-show="refreshSec==0">正在刷新</div> 
		<!-- <div class="refresh_time" v-show="refreshSec!=0">{{refreshSec}}秒后刷新</div> -->
		<div class="refresh_time" v-show="refreshSec!=0">{{refreshSec}}秒后刷新</div>
		<!--TabModal弹框组件---路线规划功能-->
		<tab-modal ref="planModal" size="small" :title="modalTitle" v-on:cancel="closeModal">
			<div>
				<div class="track_bottom_btn05">
					<i><a class="ico_01"  v-if="oneEnd" @click="switchPoints">交换位置</a></i>
					<i><a class="ico_02"  @click="addEnd">添加</a></i></div>
				<div id="planPanel">
					<div class="form-group point" v-bind:class="{ 'form-group--error': $v.startP.$error }">
						<label class="control-label">起点:</label>
						<input type="text" v-model.trim="startP" @input="$v.startP.$touch()" id="suggestId1" size="20" class="form-control" @focus.once="searchStart('suggestId1','searchResultPanel1')" />
						<div id="searchResultPanel1" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
						<span class="help-block form-group__message" v-if="!$v.startP.required">该区域不能为空</span>
					</div>
					<div class="form-group wayP" v-for="(wayInput,index) in wayInputs">
						<label class="control-label">途经点:</label>
						<input type="text" :id="'id' + index" size="20" class="form-control" @focus.once="searchInput($event,'id' + index,'resId' + index)" />
						<div :id="'resId' + index" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
					</div>
					<div class="form-group point" v-bind:class="{ 'form-group--error': $v.endPoint.$error }">
						<label for="" class="control-label">终点:</label>
						<input type="text" v-model.trim="endPoint" @input="$v.endPoint.$touch()" id="suggestId2" size="20" class="form-control" @focus.once="searchEnd('suggestId2','searchResultPanel2')" />
						<div id="searchResultPanel2" style="border:1px solid #C0C0C0;width:150px;height:auto; display:none;"></div>
						<span class="help-block form-group__message" v-if="!$v.endPoint.required">该区域不能为空</span>
					</div>
				</div>
				<div class="form-group mb0px">
					<label for="" class="control-label">规划方式:</label>
				</div>
				<div class="form-group  mb0px">
					<input type="radio" value="shortest" v-model="planMethod" class="mr5px" />距离最短
					<input type="radio" value="fastest" v-model="planMethod" class="ml20px mr5px" />速度最快
				</div>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="startPlan" :disabled="!isClickable">开始规划</button>
			</div>
		</tab-modal> 
		<!--点击车辆派单，打开派单弹框-->
		<tab-modal ref="rescueModal" size="normal" title="派单" v-on:cancel="stopDispatch">
			<div> 
				<label class="control-label">请选择待派单的救援现场：</label>
				<select class="form-control col-sm-12 mb20px" v-model="dispatchOrderId">
					<option v-for="order in dispatchOrderList" :value="order.orderId">
						<span v-if="order.orderId!=''">S{{order.orderId}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
						<span v-if="order.orderTypeName!=''">{{order.orderTypeName}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
						<span v-if="order.requestTime!=''">{{order.requestTime}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
						<span v-if="order.rescuedName!=''">{{order.rescuedName}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
						<span v-if="order.rescuedAddress!=''">{{order.rescuedAddress}}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
						<span v-if="order.distanceStr!=''">{{order.distanceStr}}</span>
					</option>
				</select> 
				<div class="col-sm-12">注：人工派单前建议先与司机联系确认</div>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="startDispatch">开始派单</button>
			</div>
		</tab-modal>
		<!--如果车辆在执行人工派单任务，弹出确认弹框-->
		<tab-modal ref="checkDispatchM" size="small" v-on:cancel="cancelDispatch" title="人工派单">
			<div>
				<label class="control-label">该车辆尚有救援任务正在执行中，您确定要向其分派新的救援任务吗？</label>
			</div>
			<div slot="footer">
				<button class="btn btn-primary" @click="cancelDispatch">取消</button>
				<button class="btn btn-primary" @click="continueDispatch">确认</button>
			</div>
		</tab-modal>
	</div>
</template>
<script>
	//引入弹框提示消息
	import {
		INFO_EMPTY,
		OPERATE_EXCEPTION
	} from 'static/message'
	//引入混合和阻止冒泡函数
	import {
		mapMixin,
		resueMixin,
		stopProp,
		tipMixin
	} from 'util/util.js'
	import {rescueMapMixin,getNameMixin} from 'util/rescueUtil'
	//引入车辆base64图标
	import {
		VEHICLE_TRACK
	} from 'static/constant.js'
	//vuex
	import {
		mapState
	} from 'vuex'
	//校验
	import {
		required
	} from 'vuelidate/lib/validators'
	//引入组件
	import StreetMap from './StreetMap' //街景
	import MenuStatus from 'components/pages/vehiclemonitor/MenuStatus' //车辆状态
	import MenuStatusRescue from 'components/pages/vehiclemonitor/MenuStatusRescue' //救援现场状态
	import TabModal from 'components/common/TabModal' //弹框
	import MenuMap from 'components/pages/vehiclemonitor/MenuMap' //地图菜单
	import MenuMapTool from 'components/pages/vehiclemonitor/MenuMapTool' //动态菜单-地图
	import MenuVehicle from 'components/pages/vehiclemonitor/MenuVehicle' //动态菜单-车辆
	import toastr from 'assets/plugins/toastr/toastr.min.js' 
	export default {
		name: 'MonitorMap',
		mixins: [mapMixin, resueMixin,rescueMapMixin,getNameMixin],
		components: {
			MenuMap,
			MenuVehicle,
			MenuMapTool,
			TabModal,
			MenuStatus,
			MenuStatusRescue,
			StreetMap
		},
		validations: {
			startP: { //起点地址
				required
			},
			endPoint: { //终点地址
				required
			}
		},
		data() {
			return {
				permission: this.$store.state.permission.permission["vehicleMonitor"] ? this.$store.state.permission.permission["vehicleMonitor"] : [],
				//地图类
				mapStyle: {
					width: '100%',
					height: '800px'
				},
				mapCenter: {
					lng: 120.39,
					lat: 36.073
				},
				mapZoom: 15,
				enableScroll: true,
				enableMapClick:false,
				loadingmap:false,
				//街景
				showStreetView: false,
				streetViewLayer:null,
				streetPosi: {
					lng: '',
					lat: ''
				}, //街景窗口的坐标信息
				//交通层
				isShowTrafficLayer: false,
				//卫星视图
				isHybridMap: false,
				//测量工具
				enableMesaureTool: false,
				//绘图工具
				enableDrawingTool: false,  
				//提示框
				labelMode:0, //地图上的标签格式（0，无、1，简洁、2，半高）
				//下方复选框状态--默认为选中
				showTrail:true,
				showCar:true,
				showFree:false,
				showStop:false,
				showRescue:true,
				//地图-定位 
				//-----将定位车辆分组 
				trailFree:[],    //拖车-空闲中
				trailFreeMarker:[],
				trailStop:[],    //拖车-已暂停
				trailStopMarker:[],
				trailRescue:[],  //拖车-救援中
				trailRescueMarker:[], 
				carFree:[],      //其他-空闲中
				carFreeMarker:[],
				carStop:[],      //其他-已暂停
				carStopMarker:[],
				carRescue:[],    //其他-救援中
				carRescueMarker:[],
				//-----轮巡相关
			 	fresh:function(){},
			 	ajaxCount:0, 
				refreshTimer: null,
				refreshSec: 300, //地图上倒计时刷新时间
				//-------右侧动态菜单
				showMenuVehicle: false, 
				vehiclePosi: {}, //当前点击车辆/设备的坐标
				vehicleAdd: [], //当前点击车辆/设备的地址 
				clickedInfo: {}, //当前点击车辆/设备的信息 
				carMarkerArr: [], //地图上的车辆标注集合 
				//tabMap操作--往地图添加围栏、路线和标注 
				currentMenu: '', //当前menumap索引  
				//弹框---共用
				modalTitle: '', //每个弹框对应的title
				//点击左侧MenuMap的时弹出菜单
				measureType: '', //测量对应菜单的索引
				//测路径
				setStart:true,
				roadStartPoint: {}, //起点坐标
				roadEndPoint: {}, //终点坐标
				transit:null,
				transitMkS:null,
				transitMkE:null,
				//测直线
				myDis: {}, //测距类实例
				measureBClicked: false, //是否点击了测直线
				lineArr: [], //测直线时的overlays
				//测面积
				measureAreaClicked: false, //是否点击了测面积
				infoType: '', //提示对应菜单的索引 
				infoWindowMenu: false, //点击左侧MenuMap的提示
				//弹框--------规划弹框
				startP: '', //路线规划起点信息，点左侧MenuMap时无默认值，点右上侧MenuVehicle时默认当前车辆位置
				startPts:null,
				endPoint: '',
				endPts:null,
				wayPoints: [], //途径点集合
				wayInputs: [], //动态添加途径点时使用
				oneEnd: true, //路线规划默认只有一个终点
				addEndCount: 0, //路线规划已添加了几个终点
				driving:null,  //规划路线时驾车方案实例
				planMethod: 'shortest', //路线规划policy
				disposeAutoComplete:false,
				//人保画面联系
				//------下方复选框状态，默认全选中
				showSceneRescue:true,
				showDispatch:false,
				showFinish:false,
				//--------将救援现场分组
				sceneToRescue:[],
				sceneToRescueMarker:[],
				sceneDispatch:[],
				sceneDispatchMarker:[],
				sceneFinish:[],
				sceneFinishMarker:[],
				ptsArr:[],				//所有定位的坐标信息集合
				//人工派单
				dispatchOrderList:[],
				dispatchOrderId:'',
				dispatchVehicleId:'', 
				resMarkerArr: [],
				//判断地图是否第一次定位TODO:用来判断是否需要改变地图中心
				firstLocateV:false,
				firstLocateR:false,
				rescuePlan:null
			}
		},
		computed: {
			...mapState({
				locateOneInfo: state => state.monitor.locateOneInfo, 
				groupId: state => state.user.groupid,
				loadMap: state => state.monitor.loadMap,
				rescueInfo: state => state.monitor.rescueInfo
			}),
			isDisable: function() {
				return this.$v.content.required
			},
			isClickable: function() {
				return this.$v.startP.required && this.$v.endPoint.required
			},
			isSearchable: function() {
				return this.$v.govAName.required
			}
		},
		watch: { 
			'rescueInfo.uni' (val) {
				const {map,BMap} = this;
				if(val != undefined) {
					let pts = this.rescueInfo.resInfo.rescuedPoints
					if(pts != '') {
						const that = this
						if(BMap) {
							this.locateRescue(that.rescueInfo.resInfo) 
						}
					} else {
						this.$store.dispatch('tipModalShow', '该救援现场无定位信息')
					}
				} else {
					this.$store.dispatch('tipModalShow', '该救援现场无法定位')
				}
			},
			locateOneInfo: function(val) { //为单个车辆定位
				const {map,BMap} = this;
				if(val == null) {
					this.$store.dispatch('tipModalShow', '该车辆无定位信息')
				} else {
					if(val.lngBd != '' && val.latBd != '') {
						if(BMap) {
							this.locateForOne(val)
						} 
					} else {
						this.$store.dispatch('tipModalShow', '该车辆无定位信息')
					}
				}
			},   
			isShowTrafficLayer: function(newVal) { //交通流量图层--trafficLayer
				const {
					map,
					trafficLayer
				} = this;
				if(newVal) {
					map.addTileLayer(trafficLayer); //将图层添加到地图上
				} else {
					map.removeTileLayer(trafficLayer); // 将图层移除
					this.trafficLayer = null;
				}
			},
			isHybridMap: function(newVal) { //展示卫星视图
				if(newVal) {
					this.currentMenu = 1;
					this.map.setMapType(BMAP_HYBRID_MAP);
					this.isShowTrafficLayer = false;
					this.enableDrawingTool = false; //去掉画图控件
					this.enableMeasureTool = false; 
				} else {
					this.map.setMapType(BMAP_NORMAL_MAP);
				}
			},
			enableDrawingTool: function(newVal) { //鼠标绘制工具
				if(!newVal) { //enableDrawingTool === false时
					this.drawingManager.close()
					$(".BMapLib_Drawing_panel").empty()
					return;
				} else {
					$(".BMapLib_Drawing_panel").css({
						height: '44px',
						border: 'none',
						borderRadius: '0',
						lineHeight: '44px'
					})
					$(".BMapLib_Drawing_panel").find('a').css({
						backgroundPosition: 'center',
						backgroundColor: '#fff',
						backgroundRepeat: 'no-repeat',
						width: '48px',
						height: '44px',
						border: 'none',
						textAlign: 'center'
					})
					$(".BMapLib_Drawing_panel").find('a').eq(0).css({
						backgroundImage: 'url(' + VEHICLE_TRACK.text_icon_31 + ')'
					})
					$(".BMapLib_Drawing_panel").find('a').eq(1).css({
						backgroundImage: 'url(' + VEHICLE_TRACK.text_icon_32 + ')'
					})
					$(".BMapLib_Drawing_panel").find('a').eq(2).css({
						backgroundImage: 'url(' + VEHICLE_TRACK.text_icon_33 + ')'
					})
					$(".BMapLib_Drawing_panel").find('a').eq(3).css({
						backgroundImage: 'url(' + VEHICLE_TRACK.text_icon_34 + ')'
					})
					$(".BMapLib_Drawing_panel a").click(function() {
						$(".BMapLib_Drawing_panel a").eq($(this).index()).css({
							backgroundColor: '#D2F0EA'
						}).siblings().css({
							backgroundColor: "#fff"
						})
					})
				} 
				if(!this.drawingManager) { 
					this.measureArea() 
				}
			},
			enableMesaureTool: function(val) {
				if(val) {
					this.currentMenu = 2;
					this.isShowTrafficLayer = false; //去掉交通层
					this.isHybridMap = false; //去掉卫星图
					this.enableDrawingTool = false; //去掉画图控件 
					this.infoWindowMenu = false;
					this.showMenuVehicle = false; 
				} else {
					this.measureType = '' 
					this.map.removeEventListener("dblclick", this.handleDbClick);
					this.map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
					this.map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
				}
			},
			infoWindowMenu: function(val) {
				if(val) {
					this.currentMenu = 4;
					this.enableMesaureTool = false;
					this.enableDrawingTool = false;
					this.isShowTrafficLayer = false; //去掉交通层
					this.isHybridMap = false; //去掉卫星图 
					this.showMenuVehicle = false;
				} else {
					this.infoType = ''
				}
			}, 
			showMenuVehicle(val) {
				if(val) {
					this.infoWindowMenu = false;
					this.enableMesaureTool = false;
					this.enableDrawingTool = false;
					this.isShowTrafficLayer = false; //去掉交通层
					this.isHybridMap = false; //去掉卫星图 
				}
			},
			'$route'(to, from) {
				if (from.path === '/indexhome') {
					clearTimeout(this.refreshTimer)
				} else if (to.path === '/indexhome') {
					this.refreshSec = 300
					this.locateLoop()
				}
			}
		}, 
		methods: {
			ready(obj) {
				const that = this;
				const {BMap,map} = obj;
				const { hideLogo, loadAsyncScript, callback, luKuang } = this;
				this.map = map;
			//	map.enableMapClick 
				this.BMap = BMap;
				map.addControl(new BMap.ScaleControl({offset:new BMap.Size(315,20)}));//比例尺控件
				//绘多边形工具
				loadAsyncScript("http://api.map.baidu.com/library/DrawingManager/1.4/src/DrawingManager_min.js", () => {});
				//				loadAsyncScript("http://api.map.baidu.com/library/SearchInfoWindow/1.4/src/SearchInfoWindow_min.js",()=>{});
				//测距工具
				loadAsyncScript("http://api.map.baidu.com/library/DistanceTool/1.2/src/DistanceTool_min.js", () => {});
				loadAsyncScript("http://api.map.baidu.com/library/GeoUtils/1.2/src/GeoUtils_min.js", () => {})
				map.disableDoubleClickZoom()
				//轮巡拉取救援车辆和救援现场，并显示倒计时提示
				this.locateLoop()  
				toastr.options={
						"closeButton":true,
						"progressBar":true
					}
			},
			locateLoop(){
				clearTimeout(this.refreshTimer)//倒计时n秒刷新
				const that = this 
				this.getRescueVehicles()
				this.getRescueScenes() 
				this.fresh = function(){  
					//添加倒计时
				 	if(that.refreshSec >= 1 && that.refreshSec <= 300) {
						that.refreshSec --
					} else {
						that.refreshSec = 300
					}
					if(that.refreshSec == 0){  
						//获取所有救援车辆  
						that.getRescueVehicles() 
						//获取所有救援现场   两个都有请求反馈后再刷新一次 
						that.getRescueScenes()  
					}else{ 
						that.refreshTimer = setTimeout(that.fresh, 1000)
					}
				}
				this.refreshTimer = setTimeout(this.fresh, 1000)
			},
			carTypeOnMap1(val){//定位在地图上的拖车（默认全选）
				const {BMap,map} = this
				const that = this;
				if(val){ 
					this.showTrail = true
					if(that.showRescue){
						that.locateForAll(that.trailRescue,13)
					} 
					if(that.showStop){
						that.locateForAll(that.trailStop,12)
					}  
					if(that.showFree){
						that.locateForAll(that.trailFree,11) 
					} 
				}else{ 
					this.showTrail = false
					this.$nextTick(()=>{
					//	that.removeMk(that.trailFreeMarker,11,that.carMarkerArr)
						for(let i = 0,len = that.trailFreeMarker.length; i < len; i ++){
							 map.removeOverlay(that.trailFreeMarker[i])
						}
						that.trailFreeMarker = []
						that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=11)
					
				//		that.removeMk(that.trailStopMarker,12,that.carMarkerArr)
						for(let i = 0,len = that.trailStopMarker.length; i < len; i ++){
							 map.removeOverlay(that.trailStopMarker[i])
						}
						that.trailStopMarker = []
						that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=12)
						
					//	that.removeMk(that.trailRescueMarker,13,that.carMarkerArr)
						for(let i = 0,len = that.trailRescueMarker.length; i < len; i ++){
							 map.removeOverlay(that.trailRescueMarker[i])
						} 
						that.trailRescueMarker = []
						that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=13) 
					}) 
				}
			},
			removeMk(typeMk,typeNo,totalMk){
				console.log(typeMk)
				console.log(totalMk)
				console.log(typeNo)
				const {BMap,map} = this
				for(let i = 0,len = typeMk.length; i < len; i ++){
					 map.removeOverlay(typeMk[i])
				}
				typeMk = []
				totalMk = totalMk.filter(n=>n.type!=typeNo)
				console.log(totalMk)
			},
			carTypeOnMap2(val){//定位在地图上的路修车（默认全选）
				const {BMap,map} = this;
				const that = this
				if(val){ 
					this.showCar = true
					if(that.showRescue){
						that.locateForAll(that.carRescue,23)
					} 
					if(that.showStop){
						that.locateForAll(that.carStop,22)
					}  	
					if(that.showFree){
						that.locateForAll(that.carFree,21) 
					}
				}else{ 
					this.showCar = false
					this.$nextTick(()=>{
						for(let i = 0,len = that.carFreeMarker.length; i < len; i ++){
							 map.removeOverlay(that.carFreeMarker[i])
						}
						that.carFreeMarker = []
						that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=21)
						
						for(let i = 0,len = that.carStopMarker.length; i < len; i ++){
							 map.removeOverlay(that.carStopMarker[i])
						}
						that.carStopMarker = []
						that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=22)
						
						for(let i = 0,len = that.carRescueMarker.length; i < len; i ++){
							 map.removeOverlay(that.carRescueMarker[i])
						} 
						that.carRescueMarker = []
						that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=23) 
					}) 
				}
			}, 
			carStatusOnMap1(val){//救援车辆的状态（空闲中）  
				const {BMap,map} = this;
				const that = this
				if(val){//定位空闲中
					this.showFree = true
					if (this.trailFree.length <= 0) {
						this.getRescueVehicles()
						this.getRescueScenes() 
					}
					if(that.showTrail){
						that.locateForAll(that.trailFree,11)
					}  
					if(that.showCar){
						that.locateForAll(that.carFree,21) 
					} 
					
				}else{
					this.showFree = false;
					this.$nextTick(()=>{
						new Promise(function(resolve,reject){
							for(let i = 0,len = that.carFreeMarker.length; i < len; i ++){
								 map.removeOverlay(that.carFreeMarker[i])
							}
							that.carFreeMarker = []
							that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=21)
							resolve()
						}).then(function(){
							for(let i = 0,len = that.trailFreeMarker.length; i < len; i ++){
								 map.removeOverlay(that.trailFreeMarker[i])
							} 
							that.trailFreeMarker = []
							that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=11)
						})
					}) 
				}
			},
			carStatusOnMap2(val){//救援车辆的状态（已暂停）
				const {BMap,map} = this;
				const that = this
				if(val){//定位已暂停
					this.showStop = true;
					if (this.trailStop.length <= 0) {
						this.getRescueVehicles()
						this.getRescueScenes() 
					}
					if(that.showTrail){
						that.locateForAll(that.trailStop,12) 
					}  
					if(that.showCar){
						that.locateForAll(that.carStop,22) 
					}  
				}else{
					this.showStop = false;
					this.$nextTick(()=>{
						new Promise(function(resolve,reject){
							for(let i = 0,len = that.trailStopMarker.length; i < len; i ++){
								 map.removeOverlay(that.trailStopMarker[i])
							}
							that.trailStopMarker = []
							that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=12)
							resolve()
						}).then(function(){
							for(let i = 0,len = that.carStopMarker.length; i < len; i ++){
								 map.removeOverlay(that.carStopMarker[i])
							} 
							that.carStopMarker = []
							that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=22)
						})
					}) 
				}
			},
			carStatusOnMap3(val){//救援车辆的状态（救援中）
				const {BMap,map} = this;
				const that = this
				if(val){//定位救援中 
					this.showRescue = true
					if(that.showTrail){
						that.locateForAll(that.trailRescue,13)
					}  
					if(that.showCar){
						that.locateForAll(that.carRescue,23) 
					}
				}else{
					this.showRescue = false
					this.$nextTick(()=>{
						new Promise(function(resolve,reject){
							for(let i = 0,len = that.trailRescueMarker.length; i < len; i ++){
								 map.removeOverlay(that.trailRescueMarker[i])
							}
							that.trailRescueMarker = []
							that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=13)
							resolve()
						}).then(function(){
							for(let i = 0,len = that.carRescueMarker.length; i < len; i ++){
								 map.removeOverlay(that.carRescueMarker[i])
							} 
							that.carRescueMarker = []
							that.carMarkerArr = that.carMarkerArr.filter(n=>n.type!=23)
						})
					}) 
				}
			},
			sceneOnMap1(val){//救援现场状态（待救援）   
				const {BMap,map} = this;
				this.showSceneRescue = val
				if(val){ 
					this.locateAllScenes(this.sceneToRescue,1) 
				}else{
					for(let i = 0,len = this.sceneToRescueMarker.length; i < len; i ++){
						map.removeOverlay(this.sceneToRescueMarker[i].mk)
					}
					this.sceneToRescueMarker = []
					this.resMarkerArr = this.resMarkerArr.filter(n=>n.type!=1)
				}
			},
			sceneOnMap2(val){//救援现场状态（已派单）  
				const {BMap,map} = this;
				this.showDispatch = val
				if(val){
					this.locateAllScenes(this.sceneDispatch,2) 
				}else{
					for(let i = 0,len = this.sceneDispatchMarker.length; i < len; i ++){
						map.removeOverlay(this.sceneDispatchMarker[i].mk)
					}
					this.sceneDispatchMarker = []
					this.resMarkerArr = this.resMarkerArr.filter(n=>n.type!=2)
				}
			},
			sceneOnMap3(val){//救援现场状态（已完成）  
				const {BMap,map} = this;
				this.showFinish = val
				if(val){
					if (this.sceneFinish.length <= 0) {
						this.getRescueVehicles()
						this.getRescueScenes() 
					}
					this.locateAllScenes(this.sceneFinish,3) 
				}else{
					for(let i = 0,len = this.sceneFinishMarker.length; i < len; i ++){
						map.removeOverlay(this.sceneFinishMarker[i].mk)
					}
					this.sceneFinishMarker = []
					this.resMarkerArr = this.resMarkerArr.filter(n=>n.type!=3)
				}
			},
			toRefresh(){//当请求成功后，重启延时器
				clearTimeout(this.refreshTimer)
				if(!this._isDestroyed){
					this.refreshTimer = setTimeout(this.fresh, 1000) 
				} 
				this.ajaxCount = 0 
			},
			getRescueVehicles(){//获取所有救援车辆并定位到地图-轮巡  
				const param = { // 6
					companyId:this.groupId
				}  
				let locate = []  
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/vehicles/locatings',{params:param}) 
				.then(res=>{   
					this.ajaxCount ++ 
					if(this.ajaxCount===2){  
						this.toRefresh()
					}
					let arr = res.body.data 
					if(arr == null) return
					//重新赋值并添加到地图  
					for(let i = 0,len = arr.length; i < len; i ++){ 
						let tmpI = this.carMarkerArr.findIndex(n=>n.obj.vehicleId == arr[i].vehicleId)  
						if(tmpI == -1){ 
							locate.push(1)
							if(arr[i].vehicleTypeId!='10' && arr[i].vehicleTypeId != '11'){
								continue
							} 
							this.setVehicleGroup(arr[i]) 
						}else{  
							locate.push(0)
							
							this.adjustOverlay(arr[i],tmpI) 
						} 
					}   
					//可以定位的条件---车辆相关复选框至少有一个选中，或有新车辆加入(车源增加或复选框更改状态)
					//如果没有更改复选框也没有新车辆加入就不用定位
					if(locate.findIndex(n=>n==1)==-1){
						return
					}
					let vehStatus = this.showTrail || this.showCar || this.showRescue || this.showFree || this.showStop 
					if(vehStatus){
						if(this.showTrail && this.showRescue){
							this.locateForAll(this.trailRescue,13)
						}
						if(this.showTrail && this.showStop){ 
							this.locateForAll(this.trailStop,12)
						}
						if(this.showTrail && this.showFree){
							this.locateForAll(this.trailFree,11)
						} 
						if(this.showCar && this.showRescue){
							this.locateForAll(this.carRescue,23)
						} 
						if(this.showCar && this.showStop){
							this.locateForAll(this.carStop,22)
						} 
						if(this.showCar && this.showFree){
							this.locateForAll(this.carFree,21)
						}  
					}  
				},res=>{  
					this.ajaxCount ++ 
					if(this.ajaxCount===2){  
						this.toRefresh()
					}
					toastr.error(res.body.message) 
				})
				.catch(res=>{   
					this.ajaxCount ++ 
					if(this.ajaxCount===2){  
						this.toRefresh()
					}
					console.log(res)
					toastr.error(OPERATE_EXCEPTION) 
				}) 
			}, 
			setVehicleGroup(info){
				let status = info.vehicleStatusId
				if(info.vehicleTypeId===10){//拖车 
					switch(status){
						case 1://空闲中 
							if(this.showTrail && this.showFree){
								this.trailFree.push(info)
							} 
							break;
						case 2://已暂停
							if(this.showTrail && this.showStop){
								this.trailStop.push(info)
							} 
							break;
						case 3://救援中
							if(this.showTrail && this.showRescue){
								this.trailRescue.push(info)
							}
							break;
						default:
							if(this.showTrail && this.showFree){
								this.trailFree.push(info)
							} 
							break;
					} 
				}
				if(info.vehicleTypeId===11){ //其他
					switch(status){
						case 1://空闲中 
							if(this.showCar && this.showFree){
								this.carFree.push(info)
							} 
							break;
						case 2://已暂停
							if(this.showCar && this.showStop){
								this.carStop.push(info)
							}
							break;
						case 3://救援中
							if(this.showCar && this.showRescue){
								this.carRescue.push(info)
							} 
							break;
						default:
							if(this.showCar && this.showFree){
								this.carFree.push(info)
							} 
							break;
					}  
				} 
			},
			getRescueScenes(){//获取所有救援现场并定位到地图-轮巡 
					const param = { 
						companyId:this.groupId
					}  
					let toLocate = [] 
					this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/rescues/locating',{params:param}) 
					.then(res=>{  
						this.ajaxCount ++ 
						if(this.ajaxCount===2){ 
							this.toRefresh()
						}
						let arr = res.body.data 
						if(arr == null){
							return
						}
						let dispatchArr = arr.filter(n=>n.rescueStatus==2)
						if(dispatchArr.length < this.sceneDispatchMarker.length){ 
							//比较两个数组找出减少的id
							let diff = []
							for(let m = 0,len = this.sceneDispatchMarker.length; m < len; m ++){
								let curObj = dispatchArr.find(n=>n.id==this.sceneDispatchMarker[m].id)
								if(curObj==undefined){
									let nowI = arr.findIndex(n=>n.id===this.sceneDispatchMarker[m].id)
									if(nowI===-1){//从已接单转成已完成
										diff.push(this.sceneDispatchMarker[m])
									} 
								} 
							}  	   
							//新数组就是需要从地图上移除的 
							const {map} = this
							for(let j = 0, l = diff.length; j < l; j ++){ 
								let tI = this.sceneDispatchMarker.findIndex(n=>n.id==diff[j].id)
								map.removeOverlay(this.sceneDispatchMarker[tI].mk)
								this.sceneDispatchMarker.splice(tI,1) 
								this.sceneDispatch.splice(tI,1)
							}
						}
						
						for(let i = 0,len = arr.length; i < len; i ++){
							let tmpR = this.resMarkerArr.findIndex(n=>n.obj.id==arr[i].id) 
							if(tmpR==-1){  
								toLocate.push(1)
								this.setSceneGroups(arr[i])
							}else{  
								toLocate.push(0)
								this.adjustScene(arr[i],tmpR)
							} 
						} 
						if(toLocate.findIndex(n=>n==1)==-1){
							return
						}
						if(this.showSceneRescue || this.showDispatch || this.showFinish){
							if(this.showFinish){
								this.locateAllScenes(this.sceneFinish,3)
							} 
							if(this.showDispatch){
								this.locateAllScenes(this.sceneDispatch,2)
							}
							if(this.showSceneRescue){
								this.locateAllScenes(this.sceneToRescue,1)
							} 
						}  
					},res=>{ 
						this.ajaxCount ++ 
						if(this.ajaxCount===2){  
							this.toRefresh()
						}
						toastr.error(res.body.message)  
					})
					.catch(res=>{  
						this.ajaxCount ++ 
						if(this.ajaxCount===2){  
							this.toRefresh()
						}
						console.log(res) 
						toastr.error(OPERATE_EXCEPTION)  
					}) 
					
			}, 
			setSceneGroups(info){
				let iRescueStatus = info.rescueStatus;
				switch (iRescueStatus){
					case 1:
						if(this.showSceneRescue){ 
							this.sceneToRescue.push(info) 
						}
						break;
					case 2:
						this.sceneDispatch.push(info) 
					 	break;
					case 3:
						if(this.showFinish){ 
					 		this.sceneFinish.push(info) 
					 	} 
					 	break;
					default:
						if(this.showSceneRescue){ 
							this.sceneToRescue.push(info) 
						}
						break;
				} 
			},
			setMapCenter(){//设置地图中心点
				const {map,BMap} = this 
				let posiArr = [] 
				for(let i = 0,len = this.ptsArr.length; i < len; i ++){
					posiArr.push(this.ptsArr[i].pts)
				}
				let v = map.getViewport(posiArr) 
				map.centerAndZoom(v.center, v.zoom)
			},
			/*
			TODO:救援现场相关
			 * */
			adjustScene(info,curIndex){
				const {map,BMap} = this;
				const that = this;
				let rMarker = this.resMarkerArr[curIndex].mk;
				//更新位置
				let newPoint = new BMap.Point(info.rescuedLngBd, info.rescuedLatBd)
				rMarker.setPosition(newPoint)
				//统计定位坐标更新
				let ptsI = this.ptsArr.findIndex(n=>n.id==info.id && n.type==0) 
				this.ptsArr.splice(ptsI,1,{pts:newPoint,id:info.id,type:0})  
				//更新救援现场图标----
				let sceneIcon = this.getSceneByStatus(info.rescueStatus)
				var myIcon = new BMap.Icon(sceneIcon, new BMap.Size(42, 52))
				rMarker.setIcon(myIcon)  
				//更新分组 
				if(info.rescueStatus==2){//待救援改为已接单
					let isDispatchI = this.sceneDispatchMarker.findIndex(n=>n.id==info.id)
					if(isDispatchI == -1){
					//	console.log('待-->已(1)   ' + info.id)
						this.sceneDispatchMarker.push({mk:rMarker,id:info.id})
						this.sceneDispatch.push(info)
						let inToRescueI = this.sceneToRescueMarker.findIndex(n=>n.id==info.id) 
						if(inToRescueI!=-1){
						//	console.log('待-->已(2)   ' + this.sceneToRescueMarker.length)
							this.sceneToRescueMarker.splice(inToRescueI,1)
							this.sceneToRescue.splice(inToRescueI,1)
						}
					}
				}else if(info.rescueStatus==1){//已接单改为待救援
					let isToRescueI = this.sceneToRescueMarker.findIndex(n=>n.id==info.id)
					if(isToRescueI == -1){
					//	console.log('已-->待(1)   ' + info.id)
						this.sceneToRescueMarker.push({mk:rMarker,id:info.id})
						this.sceneToRescue.push(info)
						let inDispatchI = this.sceneDispatchMarker.findIndex(n=>n.id==info.id) 
						if(inDispatchI!=-1){
						//	console.log('已-->待(2)   ' + this.sceneDispatchMarker.length)
							this.sceneDispatchMarker.splice(inDispatchI,1)
							this.sceneDispatch.splice(inDispatchI,1)
						}
					}
				}else{
					return;
				}
				//刷新信息窗口
				let content = this.getRescueContent(info);
				let rLabel = this.resMarkerArr[curIndex].tip
				//根据接单状态改变提示位置
				let randomNo = Math.floor(Math.random() * 5 + 1)
				let topNum = info.rescueStatus==1?-150 : -85;  
				rLabel.setOffset(new BMap.Size(randomNo, topNum)); 
				//更新提示内容
				rLabel.setContent(content) 
				let tmpI = that.resMarkerArr.findIndex(n => n.obj.id == info.id)
				this.resMarkerArr.splice(tmpI,1,{
					mk: rMarker,
					tip:rLabel, 
					obj: info,
					type:info.rescueStatus
				}) 
				/*rMarker.addEventListener('click',function(){ 
					if(rLabel){
						rLabel.show()
					} 
				})*/
			//	console.log($('.BMapLabel .id_' + info.id).length)
				if($('.BMapLabel .id_' + info.id).length == 0) return;
				//6,注册事件 
				$('.BMapLabel .id_' + info.id).parent().css('top', '') 
				this.setSceneFunc(info,rMarker,rLabel)
			},
			setSceneFunc(info,rMarker,rLabel){
				const that =this;
				const {map,BMap} = this;
				setTimeout(()=>{ 
						$('.BMapLabel .id_' + info.id).click(function(e) { 
						let i = that.resMarkerArr.findIndex(n => n.obj.id == info.id)
						var targetN = e.target,
							nodeName = targetN.nodeName.toLowerCase(),
							className = targetN.className;
						if(className.indexOf('marker_close') != -1){//关闭提示框--公共  
						//	console.log('hide')
							rLabel.hide()
						}
						if(className.indexOf('rescue_detail') != -1) {//打开救援单详情--公共
							that.showRescueDetail(info.id)
						}
						if(className.indexOf('rescue_remove') != -1) {//在已完成或已撤单时可以移除救援现场
							map.removeOverlay(rMarker)
							that.resMarkerArr.splice(i, 1)
						} 
						if(className.indexOf('rescue_locate') != -1) {//定位救援车-已接单时可以
							that.locateDriver(info.vehicleId)
						}
					})
					},0) 
			},
			setSceneLabel(info){
				let content = this.getRescueContent(info) 
				//根据接单状态改变提示位置
				let randomNo = Math.floor(Math.random() * 5 + 1)
				let topNum = info.rescueStatus==1?-150 : -85;  
				let label = this.setLocLabel(content,randomNo,topNum)  
				label.setStyle({
					border: 'none',
					background: 'none',
					bottom: '5px'
				});
				this.setTop(info)
				const that = this;
				label.addEventListener('click', function() {
					that.setTop(info)
				}) 
				return label;
			}, 
			locateAllScenes(arr,type){//定位多个救援现场   
				const {BMap,map} = this
				const that = this;
			//	console.log(type)
				for(let i = 0,len = arr.length; i < len; i ++){
					let tmpI = this.resMarkerArr.findIndex(n=>n.obj.id===arr[i].id)
					if(tmpI===-1){ 
						let randomNo = Math.floor(Math.random() * 10 + 5)    
						//统计定位坐标
						let point = new BMap.Point(arr[i].rescuedLngBd,arr[i].rescuedLatBd)
						this.ptsArr.push({pts:point,id:arr[i].id,type:0})
						//添加marker
						let icon = this.getSceneByStatus(arr[i].rescueStatus)
						let marker = this.setLocMarker(icon,point,42,52) 
						marker.setOffset(new BMap.Size(randomNo,randomNo))
						map.addOverlay(marker) 
						let label = this.setSceneLabel(arr[i]);  
						let addLabel = false;
						//所有救援现场定位点集合
						this.resMarkerArr.push({
							mk: marker,
							tip:label,
							obj: arr[i],
							type:type
						})
						//各状态下的救援现场定位点集合
						if(type==1){//待救援现场
							this.sceneToRescueMarker.push({mk:marker,id:arr[i].id})
						}else if(type==2){//已派单
							this.sceneDispatchMarker.push({mk:marker,id:arr[i].id})
						}else{//已完成
							this.sceneFinishMarker.push({mk:marker,id:arr[i].id})
						} 
						marker.addEventListener('click',function(){ 
							if(!addLabel){
								marker.setLabel(label)
								addLabel = true
							}else{
								if(label){
									label.show()
								}
							}
						//	console.log(i + '<-i   ' + '   arrayLength->' + arr.length)
						//	console.log(i > arr.length - 1)
							if(i > arr.length - 1) return;
						//	console.log('注册事件')
							 //6,注册事件 
							$('.BMapLabel .id_' + arr[i].id).parent().css('top', '') 
							that.setSceneFunc(arr[i],marker,label) 
						})  
					}	
				} 
				//9，设置地图中心点---  
				if(!this.firstLocateV){  
					this.setMapCenter() 
					this.firstLocateV = true
				} 
			},
			locateRescue(val) {//定位单个救援现场
				//根据定位现场的状态以及复选框选中状态判断是否定位。不能定位给出相应提示
				let locAblity = this.checkLocAblity(val.rescueStatus)
				if(!locAblity){
					return
				}
				let tmpI = this.resMarkerArr.findIndex(n => n.obj.id == val.id)
				if(tmpI == -1) {
					this.locateRescueToMap(val)
				} else {
					const { map } = this;
					map.removeOverlay(this.resMarkerArr[tmpI].mk)
					this.resMarkerArr[tmpI].tip = null;
					this.resMarkerArr.splice(tmpI, 1)
					this.locateRescueToMap(val)
				}
			},
			checkLocAblity(status){ 
				let locAblity = true
				switch(status){
					case 1:
						if(!this.showSceneRescue){
							this.$store.dispatch('tipModalShow','目前地图不显示‘待救援’现场，请在地图右下方‘现场’菜单区域进行设置')
							locAblity = false
						}
						break;
					case 2:
						if(!this.showDispatch){
							this.$store.dispatch('tipModalShow','目前地图不显示‘已派单’现场，请在地图右下方‘现场’菜单区域进行设置')
							locAblity =  false
						}
						break;
					case 3:
						if(!this.showFinish){
							this.$store.dispatch('tipModalShow','目前地图不显示‘已完成’现场，请在地图右下方‘现场’菜单区域进行设置')
							locAblity =  false
						}
						break;	
					default:
						locAblity =  true;
						break;
				}
				return locAblity;
			},
			locateRescueToMap(val) {
				const {
					BMap,
					map
				} = this;
				const that = this;
				//1,现场icon
				let icon = this.getSceneByStatus(val.rescueStatus)
				var myIcon = new BMap.Icon(icon, new BMap.Size(42, 52))
					//2,画marker
				let point = new BMap.Point(val.rescuedLngBd,val.rescuedLatBd)
				//统计定位坐标
				this.ptsArr.push({pts:point,id:val.id,type:0})
				//3,定位 
				map.centerAndZoom(point, 18)
				let randomNo = Math.floor(Math.random() * 10 + 5)
				//4,添加marker
				let marker = new BMap.Marker(point, {
					icon: myIcon,
					enableMassClear: false
				}) 
				marker.setOffset(new BMap.Size(randomNo,randomNo))
				map.addOverlay(marker)  
				let label;
				marker.addEventListener('click', function() {  
					if(marker.getLabel()) return; 
					//5,添加label
					let i = that.resMarkerArr.findIndex(n => n.obj.id == val.id)
				//	console.log('one-obj-' + that.resMarkerArr[i].obj.rescueStage)
				//	console.log('one-val-' + val.rescueStage)
					if(that.resMarkerArr[i].obj.rescueStage!=val.rescueStage) return;
					label = that.setSceneLabel(that.resMarkerArr[i].obj); 
					that.resMarkerArr[i].tip = label;
					marker.setLabel(label)
					//详细信息--根据接单状态判断其默认是否展开 
					that.setTop(val) 
					//6,注册事件
					$('.BMapLabel .id_' + val.id).parent().css('top', '')
					that.setSceneFunc(val,marker,label)
				})  
				label= this.setSceneLabel(val);
				marker.setLabel(label) 
				this.updateResMarkerArr(val,marker,label) 
				$('.BMapLabel .id_' + val.id).parent().css('top', '')
				//6,注册事件
				this.setSceneFunc(val,marker,label)
			},
			updateResMarkerArr(val,marker,label){
				if(val.rescueStatus==1){//待救援现场
					this.sceneToRescueMarker.push({mk:marker,id:val.id}) 
					this.sceneToRescue.push(val)
					this.resMarkerArr.push({
						mk: marker,
						tip:label,
						obj: val,
						type:1
					}) 
				}else if(val.rescueStatus==2){//已派单
					this.sceneDispatchMarker.push({mk:marker,id:val.id})
					this.sceneDispatch.push(val)
					this.resMarkerArr.push({
						mk: marker,
						tip:label,
						obj: val,
						type:2
					}) 
				}else if(val.rescueStatus==3){//已完成
					this.sceneFinishMarker.push({mk:marker,id:val.id})
					this.sceneFinish.push(val)
					this.resMarkerArr.push({
						mk: marker,
						tip:label,
						obj: val,
						type:3
					}) 
				}else{
					return
				}  
			}, 
			locateDriver(vId){//定位救援车---单车定位
				this.$store.dispatch('locateOne',vId)
			},
			showRescueDetail(id) {//打开救援单详情--公共
				const obj = {
						name:'RS' + id + '-救援单详情', 
						id:'PageRescueServiceOrderEdit',
						route:'/indexhome/rescueServiceOrderEdit' + id,
						No:'rescueServiceOrderEdit' + id,
						params:{id: id,detailMode:1}
				}
				this.$router.push({path:'/indexhome/rescueServiceOrderEdit' + id,query:obj.params});
				this.$store.dispatch('addTab',obj);
			},
			setTop(val) {//设置救援现场marker的层级
				let resA = this.resMarkerArr; 
				if(resA.length === 0) return;
				if(resA.length > 1) {
					for(let i = 0, length = this.resMarkerArr.length; i < length; i++) { //被点击的在最上面
						if(this.resMarkerArr[i].obj.id == val.id) {
							this.resMarkerArr[i].mk.setTop(true)
						} else {
							this.resMarkerArr[i].mk.setTop(false)
							for(let j = 0, length = this.carMarkerArr.length; j < length; j++) {
								this.carMarkerArr[j].mk.setTop(false)
							}
						}
					}
				} else {
					this.resMarkerArr[0].mk.setTop(true)
					for(let j = 0, length = this.carMarkerArr.length; j < length; j++) { 
						this.carMarkerArr[j].mk.setTop(false)
					}
				}
			},
			getRescueContent(info){
				let content;
				if(info.rescueStatus==1){//未接单--待救援
					content = this.setRescueInfo(info)   //未接单
				}else{//已接单
					if(info.rescueStatus==3){//已完成或已撤单时显示移除按钮
						info.removeBtn = 'dis_block'	
						info.stLine = 'st_3line'
					}else{
						info.removeBtn = 'dis_none'	
						info.stLine = 'st_2line'
					}
					content = this.setRescueInfo2(info)  
				}
				return content;
			},
			setRescueInfo(info) {//救援现场--未接单,默认全展开 
				let content = `
					<div class="car_info_box_picc id_${info.id} ">
						<dl>
							<dt class="dt_text">
								<em>S${info.id}  
									<a class="marker_close"></a>
								</em>
								<div class="sub-info-box"> 
									<span>${info.rescuedName == ''?'':info.rescuedName + ' | '}  ${info.rescuedPhone}</span>
									<i>${info.requestTimeNote} | ${info.rescueTypeName}救援 | ${info.rescuedAddress}</i>
								</div> 
							</dt>
							<dd class="main-info-box dd_data">
								<p> 
									<i>状态：${info.rescueStageName}</i>
								</p>
							</dd>
							<dd class="dd_btn">
								<strong class="sub-info-box st_1line">
									<a class="rescue_detail">救援单</a> 
								</strong>
							</dd>	  
						</dl>
					</div>`
				return content;
				/*<a class="rescue_remove">区域雷达</a>*/
			},
			setRescueInfo2(info) {//救援现场--已接单
				let content = `
					<div class="car_info_box_picc id_${info.id} ">
						<dl>
							<dt class="dt_text">
								<em>
									<span>
									 	<strong class="weight">S${info.id}</strong> 
									 	<em>${info.rescueTypeName} | ${info.requestTimeNote}</em>
									</span>
									<a class="marker_close"></a>
								</em>
								<div class="sub-info-box"> 
									<i> ${info.rescuedName == ''? '': info.rescuedName + ' | '} ${info.rescuedPhone}| ${info.rescuedAddress}</i>
								</div> 
							</dt>
							<dd class="main-info-box dd_data">
								<p>
									<i>状态：${info.rescueStatusName}  接单时间： ${info.orderTimeNote}</i>  
									<i class="sub-info-box">  ${info.plateNumber==''?'': info.plateNumber + ' | '} ${info.customerName}</i>
									<i class="sub-info-box">${info.driverName} | ${info.rescueDriverPhone}</i>
								 </p> 
							</dd>	
							<dd class="dd_btn ">
							<strong class="sub-info-box ${info.stLine}">
									<a class="rescue_detail">救援单</a>
									<a class="rescue_locate">定位救援车</a>
									<a class="rescue_remove ${info.removeBtn}">移除</a>
								</strong>
							  </dd>
						</dl>
					</div>`
				return content;
			}, 
			getSceneByStatus(status){
			 	const iconName = this.getSceneIconName(status)
			 	const iconUrl = this.getSceneIcon(iconName) 
			 	return iconUrl
			}, 
			/*
			 TODO:救援车辆有关：
			 * */ 
			adjustOverlay(info, markerIndex) { //随着定位信息改变，动态改变定位属性 
				const {map,BMap} = this;
				let aMarker = this.carMarkerArr[markerIndex].mk;
				//1，更新位置
				let newPoint = new BMap.Point(info.lngBd, info.latBd)
				aMarker.setPosition(newPoint)
				//2，统计定位坐标更新
				let ptsI = this.ptsArr.findIndex(n=>n.id==info.vehicleId && n.type==1) 
				this.ptsArr.splice(ptsI,1,{pts:newPoint,id:info.vehicleId,type:1}) 
				//3，更新车辆----1,车辆icon/设备icon
				let carIcon = this.getIconUrl(info)
				if(!carIcon) return 
				info.icon = carIcon
				var myIcon = new BMap.Icon(carIcon, new BMap.Size(28, 28))
				aMarker.setIcon(myIcon)
				//4,设备标识（主设备还是非主设备）
				let aDeviceIcon = info.mainFlag == '1' ? 'vd02_icon' : 'vd_icon'
				info.deviceIcon = aDeviceIcon 
				//5，保持提示框状态---》 
				let aLabel = this.carMarkerArr[markerIndex].label;  
				let dlClassArr = document.querySelector('.BMapLabel .id_' + info.vehicleId).classList  
				info.sizeMode = dlClassArr.item(3)
				//6,label车辆是否选中的样式
			//	let eleLabel = $('.BMapLabel').find('.id_' + info.vehicleId)
				let dlClass = $('.BMapLabel').find('.id_' + info.vehicleId).find('dl').attr('class')
				if(dlClass.indexOf('car_info_border') == -1) {
					info.clicked = ''
				} else {
					info.clicked = 'car_info_border'
				} 
				//是否点击了路线规划-是的话要保持其状态
				
				if(info.orderInfoList.length>0){ 
					let routePlan = $('.BMapLabel').find('.id_' + info.vehicleId).find('.pp_ico').children('.marker_device');
					routePlan.each(function(index,ele){  
						if($(ele).attr('class').indexOf('active')!=-1){ 
							if(info.orderInfoList.length - 1 >= index){
								let oClass = $(ele).attr('class').split(' ')[1]
								const orderLng = oClass.split('_')[2]
								const orderLat = oClass.split('_')[3] 
								if(info.orderInfoList[index].orderLngBd==orderLng && info.orderInfoList[index].orderLatBd==orderLat){
								//	console.log(index)
									info.orderInfoList[index].active = 'active'
								} 
							} 
						}
					}) 
				}
				//7，label里权限设置---档案是否显示
				if(this.permission.indexOf('vehicleMonitor_panelExpansionPointFile') == -1) {
					info.file = 'dis_block'
				} else {
					info.file = 'dis_none'
				}
				//根据是否接单判断提示框内的内容
				let labelContent = this.setCarTip(info); 
				aLabel.setContent(labelContent)
				aMarker.setLabel(aLabel) //更新label内容
					//8,注册事件
				$('.BMapLabel .id_' + info.vehicleId).parent().css('top', '');
				const _self = this;
				let aBox = aLabel.V.children[0]
				aBox.addEventListener('click', function(e) {
					var evt = e || window.event,
						targetN = evt.srcElement ? evt.srcElement : evt.target,
						nodeName = targetN.nodeName.toLowerCase(),
						className = targetN.className;
					if(className.indexOf('marker_close') != -1) {//关闭   从全高-无（简洁）
						_self.setSmallerLabel(info.vehicleId)
					}	
					if(className.indexOf('marker_file') != -1) {
						_self.goCarFile(info.plateNumber, info.vehicleId)
					} 
					if(className.indexOf('marker_order_') != -1){//跳转到救援单详情
						const orderNum = className.split('_')[3] 
						_self.showRescueDetail(orderNum) 
					} 
					if(className.indexOf('route_plan_') != -1) {//路线规划-已接单
						let oClass = className.split(' ')[1]
						const orderLngBd = oClass.split('_')[2]
						const orderLatBd = oClass.split('_')[3]  
						_self.setDrivingPlan(info.vehicleId,aMarker,info.lngBd,info.latBd,orderLngBd,orderLatBd)
						$(evt.target).addClass('active').parents('.dd_data').siblings().find('.marker_device').removeClass('active') 
					}
					if(className.indexOf('marker_dispatch') != -1) {//派单
						_self.dispatchOrder(info.lngBd,info.latBd,info.vehicleId) 
					} 
				})
				this.updateToolTip() 
			},
			locateForOne(val) { //单车定位
				const {
					map,
					BMap
				} = this;
				if(val.lngBd != null && val.latBd != null) {
					let mIndex = this.carMarkerArr.findIndex(n => n.obj.vehicleId == val.vehicleId)
					if(mIndex == -1) { //该辆车未定过位
						this.locateOneToMap(val)
					} else { //该辆车已定过位-删掉重绘
						let index = this.carMarkerArr.findIndex(n => n.obj.vehicleId == val.vehicleId)
						map.removeOverlay(this.carMarkerArr[index].mk)
						this.carMarkerArr.splice(index, 1) 
						this.locateOneToMap(val)
					}
				}
			},
			locateOneToMap(info) { //为单辆车定位
				const {
					BMap,
					map
				} = this;
				//1,车辆icon
				let icon = this.getIconUrl(info)  
				if(!icon) {
					this.$store.dispatch('tipModalShow',`车辆信息维护有误，请<a class="${'go_file' + info.vehicleId}">点此</a>前往车辆档案进行修改。`)	
					const that = this
					this.$nextTick(()=>{
						$('.go_file' + info.vehicleId).click(function(){
							that.goCarFile(info.plateNumber, info.vehicleId)
							that.$store.dispatch('tipModalHide')
						})
					})
					return
				}
				info.icon = icon
				//2,设备标识（主设备还是非主设备）
				let deviceIcon = info.mainFlag == '1' ? 'vd02_icon' : 'vd_icon'
				info.deviceIcon = deviceIcon
				//4，根据接单状态判断提示状态---》v1.6.0已变更为：默认最大化
				if(info.orderInfoList.length==0){
				 	info.sizeMode = 'maxSizeFree'   //未接单--简洁模式   mid-- -130  max -178  min  -102
				}else{
				 	info.sizeMode = 'maxSizeBusy'   //已接单--半高模式   mid   -196  max -242  min  -132 
				}
				//5,默认有提示信息
				$('.BMapLabel .id_' + info.vehicleId).parent().css('top','')
				//6,label是否处于点击后的样式
				info.clicked = '' 
				//7,label里权限设置---档案是否显示 
				if(this.permission.indexOf('vehicleMonitor_panelExpansionPointFile') == -1) {
					info.file = 'dis_block'
				} else {
					info.file = 'dis_none'
				}
				//9，添加车辆标注
				this.drawCarMarker(info) 
				//11,设置地图中心点TODO:
				const point = new BMap.Point(info.lngBd, info.latBd)
			//	map.setCenter(point)
				map.centerAndZoom(point, 18)
			},
			drawCarMarker(info) { //单车定位时添加车辆标注 
				const {
					map,
					BMap
				} = this;
				const that = this;
				let point = new BMap.Point(info.lngBd, info.latBd)
				let myIcon = new BMap.Icon(info.icon, new BMap.Size(28, 28));
				var marker = new BMap.Marker(point, {
					icon: myIcon,
					enableMassClear: false
				}) 
				let randomNo = Math.floor(Math.random() * 5 + 1)
				marker.setOffset(new BMap.Size(randomNo,randomNo))
				marker.addEventListener('click', function(e) {
					stopProp(e)
					that.vehicleSelected(info)
					that.setCarTop(info.vehicleId)
				})
				map.addOverlay(marker)
				//统计定位坐标 
				this.ptsArr.push({pts:point,id:info.vehicleId,type:1})
				//根据是否接单来渲染提示内容 
				let content = this.setCarTip(info); 
				var label = new BMap.Label(content); 
				let topNum = this.getLabelPos(info.sizeMode)
				label.setOffset(new BMap.Size(randomNo, topNum)); 
				label.setStyle({
					border: 'none',
					background: 'none',
					bottom: '5px'
				});
				marker.setLabel(label) 
				label.addEventListener('click', function(e) {
					stopProp(e)
					that.setCarTop(info.vehicleId) 
				})  
				$('.BMapLabel .id_' + info.vehicleId).click(function(e) {
					var evt = e || window.event;
					var targetN = evt.target,
						nodeName = targetN.nodeName.toLowerCase(),
						className = targetN.className;
					if(className.indexOf('marker_close') != -1) {//关闭   从全高-无（简洁）
						that.setSmallerLabel(info.vehicleId)
					}
					if(className.indexOf('marker_file') != -1) {//档案
						that.goCarFile(info.plateNumber, info.vehicleId)
					} 
					if(className.indexOf('marker_order_') != -1){//跳转到救援单详情
						const orderNum = className.split('_')[3] 
						that.showRescueDetail(orderNum) 
					}
					if(className.indexOf('route_plan_') != -1) {//路线规划-已接单
						let oClass = className.split(' ')[1]
						const orderLngBd = oClass.split('_')[2]
						const orderLatBd = oClass.split('_')[3]  
						that.setDrivingPlan(info.vehicleId,marker,info.lngBd,info.latBd,orderLngBd,orderLatBd)
						$(evt.target).addClass('active').parents('.dd_data').siblings().find('.marker_device').removeClass('active') 
					}
					if(className.indexOf('marker_dispatch') != -1) {//派单
						that.dispatchOrder(info.lngBd,info.latBd,info.vehicleId) 
					}
				})  
				this.updateToolTip()  
				let status = info.vehicleStatusId
				if(info.vehicleTypeId==1){//trail  
					if(status=='1'){//空闲中
						this.trailFreeMarker.push(marker)
						this.updateCarMarkerArr(11,marker,label,info) 
					}else if(status == '2'){//已暂停
						this.trailStopMarker.push(marker)
						this.updateCarMarkerArr(12,marker,label,info) 
					}else{//救援中
						this.trailRescueMarker.push(marker)
						this.updateCarMarkerArr(13,marker,label,info) 
					}
				}else{
					if(status=='1'){//空闲中
						this.carFreeMarker.push(marker)
						this.updateCarMarkerArr(21,marker,label,info) 
					}else if(status == '2'){//已暂停
						this.carStopMarker.push(marker)
						this.updateCarMarkerArr(22,marker,label,info) 
					}else{//救援中
						this.carRescueMarker.push(marker)
						this.updateCarMarkerArr(23,marker,label,info) 
					}
				}
				this.setCarTop(info.vehicleId)
				this.vehicleSelected(info)
			},
			locateForAll(val,type) { //多车定位 
				const { BMap, map } = this; 
				/*for(let j = 0,len = this.carMarkerArr.length; j < len; j ++){
					map.removeOverlay(this.carMarkerArr[j].mk)
				}
				this.carRescueMarker = []
				this.carStopMarker = []
				this.carFreeMarker = []
				this.trailRescueMarker = []
				this.trailStopMarker = []
				this.trailFreeMarker = []
				this.ptsArr = this.ptsArr.filter(n=>n.type!=1)*/  
				for(let i = 0, length = val.length; i < length; i++) { 
					if(val[i] !== null) {
						if(val[i].lngBd != '' && val[i].latBd != '') { 
							let tmpI = this.carMarkerArr.findIndex(n=>n.obj.vehicleId==val[i].vehicleId) 
							if(tmpI == -1){
								//1,车辆icon
								let icon = this.getIconUrl(val[i])
								if(!icon) continue
								val[i].icon = icon
								//2,设备标识（主设备还是非主设备）
								let deviceIcon = val[i].mainFlag == '1' ? 'vd02_icon' : 'vd_icon'
								val[i].deviceIcon = deviceIcon
								//4，根据接单状态和提示模式（无 简洁 半高）判断提示状态---》 v1.6.0已变更为默认不显示气泡窗体
								if(val[i].orderInfoList.length==0){
									val[i].sizeMode = 'noSizeFree'
								}else{
									val[i].sizeMode = 'noSizeBusy'
								} 
									//6,label是否处于点击后的样式
									val[i].clicked = ''
								//8，label里权限设置---档案是否显示 
								if(this.permission.indexOf('vehicleMonitor_panelExpansionPointFile') == -1) {
									val[i].file = 'dis_block'
								} else {
									val[i].file = 'dis_none'
								}
								this.getCarMarker(val[i],type)
								$('.BMapLabel .id_' + val[i].vehicleId).parent().css('top','')
							} 	
						}
					}
				}  
				//9，设置地图中心点---  
				if(!this.firstLocateR){  
					this.setMapCenter() 
					this.firstLocateR = true
				} 
			},
			getCarMarker(info,type) {  
				const {
					map,
					BMap
				} = this;
				const that = this;
				let point = new BMap.Point(info.lngBd, info.latBd)
				let myIcon = new BMap.Icon(info.icon, new BMap.Size(28, 28)); 
				let randomNo = Math.floor(Math.random() * 5 + 1)
				var marker = new BMap.Marker(point, {
					icon: myIcon,
					enableMassClear: false
				}) 
				marker.setOffset(new BMap.Size(randomNo,randomNo))
				marker.addEventListener('click', function() {
					that.vehicleSelected(info) 
					that.setCarTop(info.vehicleId) 
				})
				map.addOverlay(marker)
				//统计定位坐标
				this.ptsArr.push({pts:point,id:info.vehicleId,type:1})
				//设置定位内容
				let content = this.setCarTip(info) 
				var label = new BMap.Label(content); 
				let topNum = this.getLabelPos(info.sizeMode)
				label.setOffset(new BMap.Size(randomNo, topNum));
				label.setStyle({
					border: 'none',
					background: 'none',
					bottom: '5px'
				});
				marker.setLabel(label)
				label.addEventListener('click', function(e) {
					that.setCarTop(info.vehicleId)
				})
				setTimeout(()=> {
					$('.BMapLabel .id_' + info.vehicleId).click(function(e) { 
						var evt = e || window.event;
						var targetN = evt.target,
							nodeName = targetN.nodeName.toLowerCase(),
							className = targetN.className;
						if(className.indexOf('marker_close') != -1) {//关闭   从全高-无（简洁）
							that.setSmallerLabel(info.vehicleId)
						}
						if(className.indexOf('marker_file') != -1) {//档案-公共
							that.goCarFile(info.plateNumber, info.vehicleId)
						} 
						if(className.indexOf('marker_order_') != -1){//跳转到救援单详情 
							const orderNum = className.split('_')[3] 
							that.showRescueDetail(orderNum)
						//	$(e.target).addClass('active').parents('.dd_data').siblings().find('.marker_order').removeClass('active') 
						}
						if(className.indexOf('route_plan_') != -1) {//路线规划-已接单
							let oClass = className.split(' ')[1]
							const orderLngBd = oClass.split('_')[2]
							const orderLatBd = oClass.split('_')[3]  
							that.setDrivingPlan(info.vehicleId,marker,info.lngBd,info.latBd,orderLngBd,orderLatBd)
							$(evt.target).addClass('active').parents('.dd_data').siblings().find('.marker_device').removeClass('active')
						}
						if(className.indexOf('marker_dispatch') != -1) {//派单-未接单
							that.dispatchOrder(info.lngBd,info.latBd,info.vehicleId) 
						}
					})	 
					this.updateToolTip()
				},0)  
				this.updateVehicleGroup(type,marker)
				this.updateCarMarkerArr(type,marker,label,info)
			},
			setCarTip(info){
				let content;
				if(info.orderInfoList.length==0){ 
					content = this.getLabelContent(info)  //未接单
				}else{ 
					content = this.getLabelContent2(info)  //已接单
				}  
				return content;
			},
			updateVehicleGroup(type,marker){
				switch(type){
					case 11:
						this.trailFreeMarker.push(marker) 
						break;
					case 12:
						this.trailStopMarker.push(marker) 
						break;
					case 13:
						this.trailRescueMarker.push(marker) 
						break;
					case 21:
						this.carFreeMarker.push(marker) 
						break;
					case 22:
						this.carStopMarker.push(marker) 
						break;
					case 23:
						this.carRescueMarker.push(marker) 
						break;
					default:
						break;		
				}
			},
			updateCarMarkerArr(type,marker,label,info){
				this.carMarkerArr.push({
					mk: marker,
					label:label,
					obj: info,
					type:type
				}) 
			},
			vehicleSelected(info) { //点击车辆标注
				const {
					map,
					BMap
				} = this;
				this.streetPosi = {
					lng: info.lngBd,
					lat: info.latBd
				} 
				$('.car_info.id_' + info.vehicleId).parent().css('top','')
				let oLabel = $('.car_info.id_' + info.vehicleId) 
				if(oLabel.hasClass('noSizeBusy')){//已接单
					oLabel.addClass('maxSizeBusy').removeClass('noSizeBusy')
				}  
				if(oLabel.hasClass('noSizeFree')){//未接单
					oLabel.addClass('maxSizeFree').removeClass('noSizeFree')
				} 
				oLabel.find('dl').addClass('car_info_border')
				$('.car_info').not('.id_' + info.vehicleId).find('dl').removeClass('car_info_border')
				this.vehiclePosi = new BMap.Point(info.lngBd, info.latBd)
				this.clickedInfo = info;
				let myGeo = new BMap.Geocoder();
				const self = this;
				this.vehicleAdd = []
				myGeo.getLocation(this.vehiclePosi, function(rs) {
					const addComp = rs.addressComponents;
					self.vehicleAdd.push(addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber)
				}) 
				this.showMenuVehicle = true; 
			},
			setSmallerLabel(vId){//点击缩小提示框
				$('.car_info.id_' + vId).parent().css('top','')
				let aLabel = document.querySelector('.BMapLabel .id_' + vId).classList
				if(aLabel.contains('maxSizeBusy')){//若当前为全高状态，则变为半高=>变更为：全高-变简洁
					aLabel.remove('maxSizeBusy')
					aLabel.add('noSizeBusy') 
					return
				}
				if(aLabel.contains('maxSizeFree')){//若当前为全高状态，则变为半高=>变更为：全高-变简洁
					aLabel.remove('maxSizeFree')
					aLabel.add('noSizeFree') 
					return
				}
			},
			goCarFile(plateNumber, id) { //点车辆标注--档案
				if(plateNumber) {
					const obj = {
						name: plateNumber, 
						id: 'PageCarFileDetail',
						route: '/indexhome/carFileDetail' + id,
						No: 'file' + id,
						params: {
							id: id
						}
					}
					this.$router.push({
						path: '/indexhome/carFileDetail' + id,
						query: {
							id: id
						}
					});
					this.$store.dispatch('addTab', obj);
				} else {
					const obj = {
						name: "VE" + id, 
						id: 'PageCarFileDetail',
						route: '/indexhome/carFileDetail' + id,
						No: 'file' + id,
						params: {
							id: id
						}
					}
					this.$router.push({
						path: '/indexhome/carFileDetail' + id,
						query: {
							id: id
						}
					});
					this.$store.dispatch('addTab', obj);
				}
			},
			setDrivingPlan(vId,marker,driverLng,driverLat,orderLng,orderLat){//点击已接单救援车的路线规划
				const {BMap,map} = this;  
				if(this.rescuePlan){
					this.rescuePlan.clearResults();
					this.rescuePlan = null;
					//要将上一个不同车辆的路线规划样式恢复
				/*	console.log($('.BMapLabel').find('.w250px'))
					console.log($('.BMapLabel').find('.w250px').parents('.car_info_box_picc'))*/
					let routePlan = $('.BMapLabel').find('.w250px').parents('.car_info_box_picc')
					routePlan.each(function(index,ele){
						if($(ele).attr('class').indexOf('id_' + vId)==-1){ 
							$(ele).find('.marker_device').removeClass('active')
						}
					}) 
				}
				//司机位置
				let driverPosi = new BMap.Point(driverLng,driverLat)
				//救援现场位置
				let scenePosi = new BMap.Point(orderLng,orderLat) 
				const that = this; 
				//规划路线 
				let driving = this.setDrivingRoute()
				driving.search(driverPosi, scenePosi);  
				//获取路线时间
				driving.setSearchCompleteCallback(function(results) { 
					// 获取第一条方案
					var plan = results.getPlan(0);
					var duration = plan.getDuration() 
					//在救援车图标下方添加提示--预计XX（时间间隔）到达
					let content =  `<div class="car_info_box_picc04 car_info">
							<dl class="wauto">
								<dt class="dt_text">
								    <i>预计${duration}到达</i>
								</dt>
							</dl>
						</div>`
					let label = new BMap.Label(content)
					label.setOffset(new BMap.Size(0,20))
					label.setStyle({
						border: 'none',
						background: 'none',
						bottom: '5px'
					});
					marker.setLabel(label)
					//大约45s后时间提示自动消失
					setTimeout(()=>{
						map.removeOverlay(label)
					},45000) 
				}) 
				this.rescuePlan = driving;
			},
			dispatchOrder(lngBd,latBd,vId){//点击人工派单
				this.loadingmap = true				
				//暂存派单车辆信息
				this.dispatchVehicleId = vId 
				//打开人工派单弹框
				this.$refs.rescueModal.open()  
				//拉取可派单的信息
				const param = {
					companyId:this.groupId,
					lat:latBd,
					lng:lngBd
				}
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/rescues/near/order/locating',{params:param})
			//	this.$http.get('../../../../static/rescueOrder/dispatchorderlist.json')
				.then(res=>{
					this.loadingmap = false
					if(!res.body.data) return
					this.dispatchOrderList = res.body.data
				},res=>{
					this.loadingmap = false
					this.$store.dispatch('tipModalShow', res.body.message)
				})
				.catch(res=>{
					this.loadingmap = false
					this.$store.dispatch('tipModalShow', OPERATE_EXCEPTION)
				})
			}, 
			//人工派单设置
			stopDispatch(){//关闭派单
				this.$refs.rescueModal.close()
				this.dispatchOrderId = ''
			},
			startDispatch(){//开始派单 
				if(!this.dispatchOrderId){
					this.$store.dispatch('tipModalShow','请先选择待派单的救援现场')
					return;
				};
				this.loadingmap = true		
				//判断是否已经有人工派单的任务
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/rescues/check/status/' + this.dispatchVehicleId)
				.then(res=>{
					this.loadingmap = false;
					if(res.body.data){
						//调用人工派单接口
						this.enableDispatch()
					}else{
						//弹出确认窗口 
						this.$refs.checkDispatchM.open()
					}
				},res=>{
					this.loadingmap = false
					toastr.error(res.body.message)
					this.stopDispatch()
				//	this.$store.dispatch('tipModalShow',res.body.message) 
				})
				.catch(res=>{
					this.loadingmap = false
					toastr.error('请求异常')
					this.stopDispatch()
				//	this.$store.dispatch('tipModalShow','请求异常')
				}) 
			}, 
			continueDispatch(){//继续人工派单
				this.enableDispatch()
				this.$refs.checkDispatchM.close()
			},
			enableDispatch(){
				this.loadingmap = true;
				this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/monitor/rescues/' + this.dispatchOrderId + '/dispatch/' + this.dispatchVehicleId)				
				.then(res=>{
					this.loadingmap = false
					this.stopDispatch()
					this.$store.dispatch('tipModalShow','派单成功')
				},res=>{
					this.loadingmap = false
					toastr.error(res.body.message)
					this.stopDispatch()
				})
				.catch(res=>{
					this.loadingmap = false
					toastr.error('请求异常')
					this.stopDispatch()
				})
			}, 
			cancelDispatch(){//取消人工派单
				this.loadingmap = false
				this.stopDispatch()
				this.$refs.checkDispatchM.close()
			},
			getLabelPos(mode){
				let topNum = 0
				switch(mode){
					case 'minSizeFree':
						topNum = '-102'
						break;
					case 'midSizeFree':
						topNum = '-130'
						break;
					case 'maxSizeFree':
						topNum = '-178'
						break;
					case 'minSizeBusy':
						topNum = '-132'
						break;
					case 'midSizeBusy':
						topNum = '-196'
						break;
					case 'maxSizeBusy':
						topNum = '-242'
						break;	
					default:
						break;
				}
				return topNum
			},
			setCarTop(vId){//TODO:优化？
				for(let i = 0, length = this.carMarkerArr.length; i < length; i++) { //被点击的在最上面
					let specMarker = this.carMarkerArr[i]
					if(specMarker.obj.vehicleId == vId) {
						specMarker.mk.setTop(true)
					} else {
						specMarker.mk.setTop(false)
						for(let j = 0, length = this.resMarkerArr.length; j < length; j++) { //被点击的在最上面
							this.resMarkerArr[j].mk.setTop(false)
						}
					}
				}
			},
			getIconUrl(info) {
				const carIconName = this.getRescueDirectionName(info) 
				if(!carIconName){
					return  
				}
				const icon = this.getRescueUrl(carIconName)
				return icon
				
			},
			getLabelContent(info) { //未接单 未接单默认简洁：-102  
				let content = `
					<div class="car_info_box_picc car_info id_${info.vehicleId} ${info.sizeMode}">
						<dl class="${info.clicked}">
							<dt class="dt_text">
								<em>
									<span>${info.groupName}<em>${info.plateNum}</em></span>  
									<a class="marker_close"></a>
								</em>								
							    <i>
							    	${info.vehicleTypeName}  ${(!info.maximumLoad?'':info.maximumLoad / 1000)}T ${info.driverName==''?'':' | ' + info.driverName} ${info.driverPhone == ''?'': '| ' + info.driverPhone}</i>
							</dt>
							<dd class="dd_text">
							    <p>
									<i>接单率:${(info.driverOrderRate / 100) }%</i>
									<em> 好评率:${(info.driverFeedbackRate/100)}%</em>
								</p>
						    </dd>	 
							<dt class="dt_data">
								<div>
									<p>
										<i>定位于 ${info.gpsTime}</i>
										<b class="${info.deviceIcon}" data-toggle="tooltip_monitor" data-placement="right" title="VD${info.deviceId} | ${info.deviceNum}"></b>
									</p>
									<p>
										<i>速 ${info.speed}km | ${info.direction} | ${info.gpsType}</i>
									</P>
								</div>
							</dt>	
							<dd class="dd_btn">
								<strong class="st_2line">
									<a class="marker_file ${info.file}">档案</a> 
									<a class="marker_dispatch">派单</a>
								</strong>
							</dd>	  
						</dl>
					</div>`
				return content;
			},
			getLabelContent2(info) { //已接单 
				const orderTmp = this.getOrderTemp(info.orderInfoList) 
				let content = `
					<div class="car_info_box_picc car_info id_${info.vehicleId} ${info.sizeMode}">
						<dl class="w260px ${info.clicked}">
							<dt class="dt_text">
								<em>
									<span>${info.groupName}<em>${info.plateNum}</em></span>  
									<a class="marker_close"></a>
								</em>								
							    <i>${info.vehicleTypeName} ${(!info.maximumLoad?'':info.maximumLoad / 1000)}T  ${info.driverName==''?'':'| ' + info.driverName}${info.driverPhone==''?'' : '| ' + info.driverPhone}</i>
							</dt>
							<dd class="dd_text">
							    <p>
									<i>接单率:${(info.driverOrderRate / 100)}%</i>
									<em> 好评率:${(info.driverFeedbackRate/100)}%</em>
								</p>
						    </dd>	 
							<dt  class="dt_data">
								<div>
									<p>
										<i>定位于 ${info.gpsTime}</i>
										<b class="${info.deviceIcon}" data-toggle="tooltip_monitor" data-placement="right" title="VD${info.deviceId} | ${info.deviceNum}"></b>
									</p>
									<p>
										<i>速 ${info.speed}km | ${info.direction} | ${info.gpsType}</i>
									</P>
								</div>
							</dt>
							${orderTmp}	
							<dd  class="dd_btn">
								<strong class="st_2line">
									<a class="marker_file ${info.file}">档案</a> 
									<a class="marker_dispatch">派单</a>
								</strong>
							</dd>	  
						</dl>
					</div>`
				return content;
			},
			getOrderTemp(arr){  
				let strArr = arr.map((info,index)=>{
					return `<dd class="dd_data">
						<p> 
							${index + 1}.
							<i>
								<a class="marker_order marker_order_${info.orderNum}">${info.dateType==1?'(预)':''}单号:S${info.orderNum}</a>
							</i>
							<em class="f_right gray6"> 接单时间：${info.orderTime}</em>
						</p> 
						<p class="pp_ico">
							<a class="ico_01 ${info.dispatchType==1?'':'dis_none'}" data-toggle="tooltip_monitor" data-placement="right" tip="当前车辆为人工派单" title="当前车辆为人工派单"></a>
							<a class="ico_02 ${info.dispatchType==2?'':'dis_none'}" data-toggle="tooltip_monitor" data-placement="right" tip="当前车辆为自动派单" title="当前车辆为自动派单"></a>
							<a class="ico_03 ${!info.contactTimeout?'dis_none':''}" data-toggle="tooltip_monitor" data-placement="right" tip="联系超时：${info.contactTimeout}" title="联系超时：${info.contactTimeout}"></a>
							<a class="ico_04 ${!info.arriveTimeout?'dis_none':''}" data-toggle="tooltip_monitor" data-placement="right" tip="前往现场超时:前往现场路程已耗时${info.arriveTimeout}" title="前往现场超时:前往现场路程已耗时${info.arriveTimeout}分"></a>
							<a class="marker_device route_plan_${info.orderLngBd}_${info.orderLatBd} ${!info.active?'':'active'}">路线规划</a>
						</p>
					</dd>`
				})
				const str = strArr.join('')
				return str
			},
			/** 
			 * 
			 * 异步加载依赖的javascript文件 
			 * src：script的路径 
			 * callback：当外部的javascript文件被load的时候，执行的回调 
			 */
			loadAsyncScript(src, callback) {
				var srcArray = src.split("?")[0].split("/");
				var scr_src = srcArray[srcArray.length - 1];

				// 判断要 添加的脚本是否存在如果存在则不继续添加了  
				var scripts = document.getElementsByTagName("script");
				if(!!scripts && 0 != scripts.length) {
					for(var i = 0; i < scripts.length; i++) {
						if(-1 != scripts[i].src.indexOf(scr_src)) {
							callback();
							return true;
						}
					}
				}
				// 不存在需要的则添加  
				var head = document.getElementsByTagName("head")[0];
				var script = document.createElement("script");
				script.setAttribute("type", "text/javascript");
				script.setAttribute("src", src);
				script.setAttribute("async", true);
				script.setAttribute("defer", true);
				head.appendChild(script);
				if(document.all) {
					script.onreadystatechange = function() {
						var state = this.readyState;
						if(state === 'loaded' || state === 'complete') {
							callback();
						}
					}
				} else {
					//firefox, chrome  
					script.onload = function() {
						callback();
					}
				}
			},
			traffic() { //显示路况拥堵情况，切换开关，再次点击后复原
				if(!this.trafficLayer) {
					this.trafficLayer = new BMap.TrafficLayer(); // 创建交通流量图层实例    
				}
				this.currentMenu = 0
				this.isShowTrafficLayer = !this.isShowTrafficLayer;
				//	this.isShowTrafficLayer = true
				this.isHybridMap = false; //去掉卫星图
				this.enableDrawingTool = false; //去掉画图控件
				this.enableMeasureTool = false;
			},
			measureClear() { //测量时，清空地图
				this.measureType = 6;
				if(this.drawingManager) { //测过面积
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				if(this.measureBClicked) { //测过直线
					this.myDis.close()
				}
				this.map.clearOverlays()
				this.map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
				this.map.removeEventListener("dblclick", this.handleDbClick);
				this.map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件

			},
			measureRoad() { //测路径  1，获取起点、终点坐标  2，获取完终点后计算路径长度
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				const {
					map
				} = this;
				this.measureType = 0;
				this.setStart = true; 
				this.enableDrawingTool = false; //关闭测面积事件
				const self = this;
				map.removeEventListener("dblclick", this.handleDbClick); //取消双击获取坐标事件
				map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
				map.addEventListener('click', this.measureRoadClick); //1，获取起点、终点坐标	
				if(this.measureBClicked) {
					this.myDis.close()
				}
			},
			measureRoadClick(e) {
				if(!e.overlay){
					const {
						map
					} = this;
					const self = this;   
					if(this.setStart){
						this.roadStartPoint = e.point;
						this.transitMkS = new BMap.Marker(e.point)
						map.addOverlay(this.transitMkS)
						
					}else{
						this.roadEndPoint = e.point;
						this.transitMkE = new BMap.Marker(e.point)
						map.addOverlay(this.transitMkE)
						this.getRoadLength() //2，获取路径长度
					}
					this.setStart = !this.setStart
				} 
			},
			getRoadLength() { //2，from measureRoad->获取路径长度
				const {
					map
				} = this;
				const self = this;
				let output = '' 
				if(this.transit){
					this.transit.clearResults();   
				} 
				var transit = this.setDrivingRoute()
				transit.setSearchCompleteCallback(function(results){
					map.removeOverlay(self.transitMkE)
					map.removeOverlay(self.transitMkS)
					self.transitMkE = null;
					self.transitMkS = null;
					if(transit.getStatus() != BMAP_STATUS_SUCCESS) {//当规划失败 
						self.transit.clearResults();
						self.$store.dispatch('tipModalShow', '地图规划行驶方案失败，请合理调整您的路线') 
						return;
					} 
					var plan = results.getPlan(0); 
					output += "总路程为：";
					output += plan.getDistance(true) + "\n"; //获取距离
					self.$store.dispatch('tipModalShow', output) 
				})
				transit.search(this.roadStartPoint, this.roadEndPoint); 
				this.transit = transit;
			},
			measureBeeline() { // 测直线
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				this.measureBClicked = true;
				const {
					map
				} = this;
				const self = this;
				this.measureType = 1;
				map.removeEventListener("dblclick", this.handleDbClick);
				map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
				map.removeEventListener('click', this.measureRoadClick); //取消测路径事件的绑定
				this.enableDrawingTool = false; //取消测面积事件
				map.setDefaultCursor('point') //改变鼠标样式
				var myDis = new BMapLib.DistanceTool(map, {
					lineStroke: 2
				});
				myDis.open()
				myDis.addEventListener("drawend", function(e) {
					$('.BMapLabel').css({
							border: 'none',
							backgroundColor: 'rgba(255,255,255,0)'
						})
						//	self.$store.dispatch('tipModalShow','总长' + e.distance + '米')
				})
				$('.BMapLabel').css({
					border: 'none',
					backgroundColor: 'rgba(255,255,255,0)'
				})
				this.myDis = myDis
			},
			measureArea() { //测面积
				const {
					map
				} = this;
				const self = this;
				if(this.measureBClicked) {
					this.myDis.close()
				}
				map.removeEventListener("dblclick", this.handleDbClick);
				map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
				map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
				this.measureType = 2;
				if(this.measureType === 2) {
					this.enableDrawingTool = !this.enableDrawingTool; 
					this.enableMeasureTool = true;
					var styleOptions = {
							strokeColor: "red", //边线颜色。
							fillColor: "red", //填充颜色。当参数为空时，圆形将没有填充效果。
							strokeWeight: 3, //边线的宽度，以像素为单位。
							strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
							fillOpacity: 0.3, //填充的透明度，取值范围0 - 1。
							strokeStyle: 'solid' //边线的样式，solid或dashed。
						}
						//实例化鼠标绘制工具
					var drawingManager = new BMapLib.DrawingManager(map, {
						isOpen: false, //是否开启绘制模式
						enableDrawingTool: this.enableDrawingTool, //是否显示工具栏
						drawingToolOptions: {
							anchor: BMAP_ANCHOR_TOP_RIGHT, //位置
							offset: new BMap.Size(352, 10), //偏离值
							drawingModes: [
								BMAP_DRAWING_CIRCLE,
								BMAP_DRAWING_RECTANGLE,
								BMAP_DRAWING_POLYGON
							]
						},
						circleOptions: styleOptions, //圆的样式
						polygonOptions: styleOptions, //多边形的样式
						rectangleOptions: styleOptions //矩形的样式
					});
					drawingManager.enableCalculate(); //打开距离或面积计算
					//添加鼠标绘制工具监听事件，用于获取绘制结果
					drawingManager.addEventListener('overlaycomplete', function(e) {
						let areaSize = Number(e.calculate)
						self.$store.dispatch('tipModalShow', '面积为' + areaSize.toFixed(2) + '平方米')
					});
					this.drawingManager = drawingManager;
				}
			},
			getCoordinate() { // 取坐标--鼠标hover时显示坐标点，双击时选定
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
				this.enableDrawingTool = false; //取消画多边形工具
				if(this.measureBClicked) {
					this.myDis.close()
				}
				const {
					map
				} = this;
				map.setDefaultCursor('point') //改变鼠标样式
				this.measureType = 3; 
				map.addEventListener("mousemove", this.handleMouseMove);
				map.addEventListener("dblclick", this.handleDbClick);
				map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
			},
			handleMouseMove(e) { //点‘标注’->2,鼠标移动显示坐标
				const {
					map,
					BMap
				} = this;
				map.removeOverlay(this.mapLabel)
				let point = e.point;
				let infoBox = "lng" + point.lng + ' lat' + point.lat;
				if(this.markersClicked) {
					this.addLabel(point, 'dis_block')
				} else {
					this.addLabel(point, 'dis_none')
				}
			},
			handleDbClick(e) { //取坐标->3,双击鼠标设置地图中心
				this.measureType = '';
				let point = e.point;
				this.map.centerAndZoom(point, 18)
				this.map.removeEventListener('mousemove', this.handleMouseMove);
			},
			addLabel(point, display) { //添加文本标注
				const {
					BMap,
					map
				} = this;
				var opts = {
					position: point, // 指定文本标注所在的地理位置
					offset: new BMap.Size(30, -30) //设置文本偏移量
				}
				var marker = new BMap.Marker(point);
				var Label = new BMap.Label(`<p>坐标: ${point.lng},${point.lat}</p>
					<p class="${display}">单击图标保存标注</p>`);
				Label.setOffset(new BMap.Size(15, 15));
				Label.setStyle({
					padding: '10px 10px',
					color: 'red',
					border: 0,
					backgroundColor: 'none'
				})
				marker.setLabel(Label);
				map.addOverlay(marker);
				if(display == 'dis_block') {
					marker.addEventListener('click', this.saveMarker)
				}
				this.mapLabel = marker;
			},
			getAddress() { // 查地址---地址检索
				this.map.removeEventListener("dblclick", this.handleDbClick);
				this.map.removeEventListener("mousemove", this.handleMouseMove); //取消鼠标滑动事件
				this.map.removeEventListener('click', this.measureRoadClick); //取消事件的绑定
				this.measureType = 4;
				this.enableDrawingTool = false; //关闭测面积的drawingTool
				if(this.measureBClicked) {
					this.myDis.close()
				}
				if(this.drawingManager) {
					$(".BMapLib_Drawing_panel a").css({
						backgroundColor: "#fff"
					})
					this.drawingManager.close()
				}
			},
			initPlanModal(){
				this.startP = ''
				this.endPoint = ''
				this.$v.endPoint.$reset();
				this.$v.startP.$reset();
				this.wayPoints = [];
				this.oneEnd = true;
				this.wayInputs = [];
			},
			pathPlan() { // 路线规划
				this.markersClicked = false;
				this.isShowTrafficLayer = false; //去掉交通层
				this.isHybridMap = false; //去掉卫星层 
				this.enableDrawingTool = false; //去掉画图控件
				this.enableMeasureTool = false; //去掉测量动态菜单
				this.infoWindowMenu = false //去掉提示动态菜单
				this.markersClicked = false //取消点击标注的事件 
				this.currentMenu = 3;
				this.initPlanModal()
				this.$refs.planModal.open() 
				this.modalTitle = "路线规划";
			},
			addEnd() { //路线规划里-pathPlan->点击添加途径点-最多有5个途径点
				this.addEndCount++;
				if(this.addEndCount < 5) {
					this.wayInputs.push(this.addEndCount)
					this.oneEnd = false;
				}
			},
			switchPoints() { //路线规划里-pathPlan->当只有一个终点时点击切换终点和起点
				let temP = this.startP;
				this.startP = this.endPoint;
				this.endPoint = temP;
			},
			startPlan() { //路线规划里点开始规划按钮 
				this.currentMenu = ''
				this.$refs.planModal.close()
				let drivingPolicy = [BMAP_DRIVING_POLICY_LEAST_TIME, BMAP_DRIVING_POLICY_LEAST_DISTANCE]
				let i = 0;
				if(this.planMethod === 'fastest') { //速度最快
					i = 0
				} else { //最短距离
					i = 1
				}
				const { map,BMap} = this; 
				const self = this; 
				if(this.driving){ 
					this.driving.clearResults()
					this.driving = null
				}
				this.driving = this.setDrivingRoute(drivingPolicy[i])
				this.driving.setSearchCompleteCallback(function() {  
					if(self.driving.getStatus() != BMAP_STATUS_SUCCESS) {//当规划失败 
						self.$store.dispatch('tipModalShow', '地图规划行驶方案失败，请合理调整您的路线') 
						self.driving.clearResults()
						return;
					} 
				})
				if(this.oneEnd) {
					this.driving.search(this.startPts, this.endPts);
				} else {
					this.driving.search(this.startPts, this.endPts, {
						waypoints: this.wayPoints
					});
					this.wayPoints = []
				}
			},
			setDrivingRoute(drivingPolicy){
				const {map,BMap} = this;
				const self = this;
				var driving = null;
				var markersSet = function(pois){
					let sMk = pois[0].marker
					let eMk = pois[pois.length-1].marker
					let tipCnt = '<div class="plan_close"></div>'
					let label1 = new BMap.Label(tipCnt)
					let label2 = new BMap.Label(tipCnt)
					label1.setOffset(new BMap.Size(15,-10))
					label2.setOffset(new BMap.Size(15,-10))
					sMk.setLabel(label1)
					eMk.setLabel(label2)
					var toDel = function(){ 
						driving.clearResults()
						driving = null;
					}
					sMk.addEventListener('click',toDel)
					eMk.addEventListener('click',toDel) 
					label1.setStyle({
						border:0,
						background:'none',
						padding:0
					})
					label2.setStyle({
						border:0,
						background:'none',
						padding:0
					}) 
				}
				if(!drivingPolicy){
					drivingPolicy = 'BMAP_DRIVING_POLICY_LEAST_TIME'
				}
				driving = new BMap.DrivingRoute(map, {
					renderOptions: {
						map: map, 
						autoViewport: true
					},
					policy: drivingPolicy,
					onMarkersSet: markersSet
				}); 
				return driving;
			},
			setInfoWindow() { //设置车辆信息提示框-
				this.infoType = ''
				this.infoWindowMenu = !this.infoWindowMenu;
			},
			noInfo() { //无
				this.infoType = 0;
				this.labelMode = '0'  
				this.changeMode('noSizeBusy','noSizeFree')
			},
			simpleInfo() { //简洁
				this.infoType = 1;
				this.labelMode = '1'
				this.changeMode('minSizeBusy','minSizeFree')
			},
			standardInfo() { //半高
				this.infoType = 2;
				this.labelMode = '2'
				this.changeMode('midSizeBusy','midSizeFree')
			},
			changeMode(className1,className2){ 
				let oLabel = document.querySelectorAll('.BMapLabel .car_info') 
				if(oLabel.length != 0){
					for(let i = 0, len = oLabel.length; i < len; i ++){
						oLabel[i].parentNode.style.top = ''
						let arr = oLabel[i].classList  
						if(!arr.contains(className1)){
							arr.remove(arr.item(3))
							arr.add(className1)
							continue
						}else{
							continue
						}
						if(!arr.contains(className2)){
							arr.remove(arr.item(3))
							arr.add(className2) 
							continue
						}else{
							continue
						} 
					}
				}
			}, 
			jieJing() { // 街景
				const {map,BMap} = this;
				this.showStreetView = true;
				this.streetViewLayer = new BMap.PanoramaCoverageLayer()
				map.addTileLayer(this.streetViewLayer);
			},
			closeStreetView() {
				const {map,BMap} = this;
				this.showStreetView = false;
				map.removeTileLayer(this.streetViewLayer)
			},
			routePlan() { //规划 
				if(this.vehicleAdd.length == 0){
					 this.$store.dispatch('tipModalShow','获取车辆位置失败，请点击车辆重试')
					 return
				}
				this.initPlanModal()
				this.startP = this.vehicleAdd[0]; //默认值
				this.$refs.planModal.open(); 
				this.disposeAutoComplete = true;
				this.modalTitle = "为" + this.clickedInfo.groupName + '(' + this.clickedInfo.plateNum + ')' + "规划路线";
			}, 
			closeModal() { //点击弹框右上方X按钮 -->drawFences
					//2,初始化模态框
				this.$refs.planModal.close(); //弹框planModal关闭
			}, 
			searchStart(id, resId) { //输入起点提示
				var ac = this.searchCommon(id, resId)
				let newVal = ''
				const that = this;
				ac.addEventListener("onconfirm", function(e) {
					var _value = e.item.value
					newVal = _value.province + _value.city + _value.district + _value.street + _value.business;;
					G(resId).innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + newVal;
					that.switchAdsToPts(newVal,'start')
					that.startP = newVal
				})
			},
			searchEnd(id, resId) { //输入终点提示
				var ac = this.searchCommon(id, resId)
				let newVal = ''
				const that = this;
				ac.addEventListener("onconfirm", function(e) {
					var _value = e.item.value
					newVal = _value.province + _value.city + _value.district + _value.street + _value.business;;
					G(resId).innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + newVal;
					that.switchAdsToPts(newVal,'end')
					that.endPoint = newVal
				})
			},
			searchInput(event, id, resId) { //规划时输入途径点提示
				var ac = this.searchCommon(id, resId)
				let newVal = ''
				const that = this;
				ac.addEventListener("onconfirm", function(e) {
					var _value = e.item.value
					newVal = _value.province + _value.city + _value.district + _value.street + _value.business;
					G(resId).innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + newVal;
					that.switchAdsToPts(newVal,'way')
					event.target.value = newVal 
				})
			},
			switchAdsToPts(ads,type){
				const {map,BMap} = this;
				const that = this;
				let myGeo =  new BMap.Geocoder(); 
				let pts = null;
				myGeo.getPoint(ads,function(point){
					if(point){
						switch(type){
							case 'start':
								that.startPts = point;
								break;
							case 'end':
								that.endPts = point;
								break;
							case 'way':
								that.wayPoints.push(point);
								break;
							default:
								break;
						} 
					}else{
						that.$store.dispatch('tipModalShow','系统解析失败，请重新调整地址。')
						return;
					}
				}) 
			},
			searchAds() { //地址检索时的输入提示
				var ac = this.searchCommon('suggestId', 'searchResultPanel')
				var myValue;
				let self = this;
				ac.addEventListener("onconfirm", function(e) { //鼠标点击下拉列表后的事件
					var _value = e.item.value;
					myValue = _value.province + _value.city + _value.district + _value.street + _value.business;
					G("searchResultPanel").innerHTML = "onconfirm<br />index = " + e.item.index + "<br />myValue = " + myValue;
					self.setPlace(myValue);
				});
			},
			searchCommon(id, resId) {
				const {
					map,
					BMap
				} = this;
				const that = this;
				var ac = new BMap.Autocomplete( //建立一个自动完成的对象
					{
						"input": id,
						"location": map,
						onSearchComplete:function(){
							if(that.disposeAutoComplete){ 
							    ac.hide()
								that.disposeAutoComplete = false
							} 
						}
					});
				ac.addEventListener("onhighlight", function(e) { //鼠标放在下拉列表上的事件
					var str = "";
					var _value = e.fromitem.value;
					var value = "";
					if(e.fromitem.index > -1) {
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str = "FromItem<br />index = " + e.fromitem.index + "<br />value = " + value;

					value = "";
					if(e.toitem.index > -1) {
						_value = e.toitem.value;
						value = _value.province + _value.city + _value.district + _value.street + _value.business;
					}
					str += "<br />ToItem<br />index = " + e.toitem.index + "<br />value = " + value;
					G(resId).innerHTML = str;
				});
				return ac
			},
			setPlace(myValue) { //地址检索时调用的方法
				const {
					map
				} = this;
				map.clearOverlays(); //清除地图上所有覆盖物
				var myFun = function() {
					var pp = local.getResults().getPoi(0).point; //获取第一个智能搜索的结果
					map.centerAndZoom(pp, 18);
					map.addOverlay(new BMap.Marker(pp));
				}
				var local = new BMap.LocalSearch(map, { //智能搜索
					onSearchComplete: myFun
				});
				local.search(myValue);
			},
			updateToolTip(){
				this.$nextTick(function() { 
					$('[data-toggle="tooltip_monitor"]').tooltip() 
					$('[data-toggle="tooltip_monitor"]').hover(function(e){ 
					 	$(e.currentTarget).attr('data-original-title',$(e.currentTarget).attr('tip')).tooltip('fixTitle').tooltip('show') 
					 },function(e){
					 	$(e.currentTarget).attr('data-original-title','')
					}) 
				})
			}
		},  
		mounted() {
			const that = this;
		    window.onresize = function temp() {//让地图随窗口大小改变
		    	that.mapStyle.height = $('#content-main').height() + 'px'; 
		    }; 
			this.mapStyle.height = $('#content-main').height() + 'px';
			clearTimeout(this.refreshTimer) 
		}, 
		beforeDestroy() {
			clearTimeout(this.refreshTimer)
			this.refreshTimer = null  
			this.$store.dispatch('resetState')
			this.carMarkerArr = []; 
			this.ptsArr = [];
			this.$store.dispatch('dataFromRescue',{})
			$('[data-toggle="tooltip_monitor"]').tooltip('hide')
			this.$store.dispatch('openByTab',0)
		}
	}

	function G(id) {
		return document.getElementById(id);
	}
</script>


// WEBPACK FOOTER //
// MonitorMap.vue?e6ece310